(function () {
  const UNIVERSAL_ALT = 'all';

  function filterGallery(selectedValue) {
    const mediaItems = document.querySelectorAll('[id^="Slide-"]');

    if (!selectedValue) {
      mediaItems.forEach(item => item.style.display = '');
      return;
    }

    const val = selectedValue.toLowerCase().trim();
    let firstVisible = null;

    mediaItems.forEach(item => {
      const img = item.querySelector('.product__media img, img');
      const alt = img ? img.getAttribute('alt') || '' : '';
      const altLower = alt.toLowerCase().trim();

      if (altLower === UNIVERSAL_ALT) {
        item.style.display = '';
        return;
      }

      const match = altLower === val;
      item.style.display = match ? '' : 'none';
      if (match && !firstVisible) firstVisible = item;
    });

    if (firstVisible) {
      document.querySelectorAll('[id^="Slide-"]').forEach(item => {
        item.classList.remove('is-active');
      });
      firstVisible.classList.add('is-active');

      const mediaId = firstVisible.getAttribute('data-media-id')
        || firstVisible.id.split('-').pop();
      const matchingThumb = document.querySelector(
        `[data-media-id="${mediaId}"], .thumbnail-list__item [data-media-id="${mediaId}"]`
      );
      if (matchingThumb) matchingThumb.click();

      firstVisible.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  function getCheckedColor() {
    const checked = document.querySelector('input[name^="Color"]:checked');
    return checked ? checked.value : null;
  }

  // Delegated listener — survives DOM re-renders
  document.addEventListener('change', (e) => {
    if (!e.target.matches('.swatch-input__input')) return;
    const name = e.target.getAttribute('name') || '';
    if (/colou?r/i.test(name)) {
      filterGallery(e.target.value);
    }
  });

  // variant:change backup
  document.addEventListener('variant:change', (e) => {
    const variant = e.detail?.variant;
    if (!variant) return;
    filterGallery(variant.options[1]);
  });

  function init() {
    const checkedColor = getCheckedColor();
    if (checkedColor) filterGallery(checkedColor);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();